export default "__VITE_ASSET__LslRf16d__"